import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-474da1f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"700px"} }
const _hoisted_2 = { class: "chat_top" }
const _hoisted_3 = { class: "tab_list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tab_name" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除聊天")
const _hoisted_7 = {
  class: "chat_right",
  id: "chat_con"
}
const _hoisted_8 = { class: "chat_extra" }
const _hoisted_9 = {
  key: 0,
  class: "chat_name"
}
const _hoisted_10 = {
  key: 1,
  class: "chat_name"
}
const _hoisted_11 = { class: "chat_info" }
const _hoisted_12 = { class: "chat_inner" }
const _hoisted_13 = {
  key: 0,
  class: "chat_arrow_left"
}
const _hoisted_14 = {
  key: 1,
  class: "chat_arrow_right"
}
const _hoisted_15 = { class: "chat_bottom" }
const _hoisted_16 = { class: "chat_btn" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("发送")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BellOutlined = _resolveComponent("BellOutlined")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_badge, { dot: _ctx.dot }, {
      default: _withCtx(() => [
        _createVNode(_component_BellOutlined, {
          style: {"color":"#FFFFFF","font-size":"22px","cursor":"pointer"},
          onClick: _ctx.setVisible
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["dot"]),
    _createVNode(_component_a_modal, {
      title: "客服系统",
      width: "800px",
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      bodyStyle: {padding: 0},
      footer: null
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatUsers, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["tab_item", {'tab_item_active': _ctx.chatUserInfo && _ctx.chatUserInfo.id === item.id}]),
                  onClick: ($event: any) => (_ctx.setActive(item)),
                  key: item.id
                }, [
                  _createVNode(_component_a_avatar, {
                    src: item?.avatar,
                    shape: "square"
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
                  _createVNode(_component_a_tooltip, null, {
                    title: _withCtx(() => [
                      _hoisted_6
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_CloseOutlined, {
                        onClick: _withModifiers(($event: any) => (_ctx.onDelChat(item)), ["stop"])
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ], 10, _hoisted_4))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["chat_item", {'chat_item_right': item?.chatType === 'right'}]),
                  key: item?.id
                }, [
                  (item?.chatType === 'left')
                    ? (_openBlock(), _createBlock(_component_a_avatar, {
                        key: 0,
                        src: _ctx.chatUserInfo?.avatar,
                        shape: "square",
                        size: 50,
                        class: "avatar"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    (item?.chatType === 'left')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.chatUserInfo?.name), 1))
                      : _createCommentVNode("", true),
                    (item?.chatType === 'right')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.adminUserInfo?.name), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(item?.message), 1),
                      (item?.chatType === 'left')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                        : _createCommentVNode("", true),
                      (item?.chatType === 'right')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (item?.chatType === 'right')
                    ? (_openBlock(), _createBlock(_component_a_avatar, {
                        key: 1,
                        src: _ctx.adminUserInfo?.avatar,
                        shape: "square",
                        size: 50,
                        class: "avatar"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_a_textarea, {
              value: _ctx.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
              bordered: false,
              onPressEnter: _ctx.sendMsg,
              placeholder: "在此输入消息回复...",
              onKeypress: _withKeys(_ctx.onKeyListen, ["down","native"])
            }, null, 8, ["value", "onPressEnter", "onKeypress"]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.sendMsg
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}